import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  FormControlLabel,
  Switch
} from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const emptyState = {
  name: "",
  document: "",
  notes: "",
  active: true
};

const EconomicGroupModal = ({ open, onClose, economicGroupId, onSave }) => {
  const [record, setRecord] = useState(emptyState);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;

    if (!economicGroupId) {
      setRecord(emptyState);
      return;
    }

    const loadRecord = async () => {
      try {
        setLoading(true);
        const { data } = await api.get(`/economic-groups/${economicGroupId}`);
        setRecord({
          name: data.name || "",
          document: data.document || "",
          notes: data.notes || "",
          active: data.active !== false
        });
        setLoading(false);
      } catch (err) {
        setLoading(false);
        toastError(err);
      }
    };

    loadRecord();
  }, [open, economicGroupId]);

  const handleSave = async () => {
    try {
      if (!record.name || !record.name.trim()) {
        toast.error("Nome é obrigatório");
        return;
      }

      setLoading(true);

      if (economicGroupId) {
        await api.put(`/economic-groups/${economicGroupId}`, record);
        toast.success("Grupo Econômico atualizado com sucesso");
      } else {
        await api.post("/economic-groups", record);
        toast.success("Grupo Econômico criado com sucesso");
      }

      setLoading(false);
      onSave && onSave();
      onClose();
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{economicGroupId ? "Editar Grupo Econômico" : "Novo Grupo Econômico"}</DialogTitle>

      <DialogContent dividers>
        <TextField
          fullWidth
          label="Nome"
          value={record.name}
          onChange={(e) => {
            const value = e.target.value;
            setRecord(prev => ({ ...prev, name: value }));
          }}
          disabled={loading}
          style={{ marginBottom: 16 }}
        />

        <TextField
          fullWidth
          label="Documento"
          value={record.document}
          onChange={(e) => {
            const value = e.target.value;
            setRecord(prev => ({ ...prev, document: value }));
          }}
          disabled={loading}
          style={{ marginBottom: 16 }}
        />

        <TextField
          fullWidth
          multiline
          rows={3}
          label="Observações"
          value={record.notes}
          onChange={(e) => {
            const value = e.target.value;
            setRecord(prev => ({ ...prev, notes: value }));
          }}
          disabled={loading}
        />

        <FormControlLabel
          style={{ marginTop: 16 }}
          control={
            <Switch
              checked={record.active}
              onChange={(e) => {
                const checked = e.target.checked;
                setRecord(prev => ({ ...prev, active: checked }));
              }}
              color="primary"
              disabled={loading}
            />
          }
          label="Ativo"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button color="primary" variant="contained" onClick={handleSave} disabled={loading}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EconomicGroupModal;
